import React, { Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Table,
  Spinner,
  Tooltip,
} from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import apiResponse from "../../../../services/apiResponse";
import DetailBloc from "./Blocs/DetailBloc";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";
import { generateFormData } from "../../../../helpers/ui/FileInput";
import moment from "moment";

var reformatCriteria = function (datas) {
  return datas.map(function (data) {
    var newObj = {};
    newObj["label"] = data.assessment_criteria_name;
    newObj["tooltip"] = data.assessment_criteria_fullname;
    newObj["value"] = data.assessment_criteria_uuid;
    newObj["model"] = data;
    return newObj;
  });
};

class UpdatePenilaianView extends Component {
  userdata = JSON.parse(localStorage.getItem("userdata"));
  is_eselon =
    typeof this.userdata.echelon_code === "string" &&
    (this.userdata.echelon_code.startsWith("1") ||
      this.userdata.echelon_code.startsWith("2"))
      ? 1
      : 0;
  detailBloc = new DetailBloc();

  submitData = async () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const uuid = queryParams.get("uuid");
    let formData = generateFormData();
    formData.append("uuid", uuid);

    this.state.components.forEach((data) => {
      formData.append(data, document.getElementsByName(data)[0].value);
    });
    await this.detailBloc.fetchCreate(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  checkCurrentMonth = () => {
    if (this.state.roleId == 2 && this.is_eselon == 1) {
      return parseInt(this.state.currentYear) ==
        parseInt(this.state.yearPresensi) &&
        parseInt(this.state.currentMonth) ==
          parseInt(this.state.monthPresensi) &&
        this.state.currentDay >= this.state.configStartDateEselon &&
        this.state.currentDay <= this.state.configEndDateEselon
        ? 1
        : 0;
    }
    // administrator
    else if (this.state.roleId == 1) {
      return parseInt(this.state.currentYear) ==
        parseInt(this.state.yearPresensi) &&
        parseInt(this.state.currentMonth) ==
          parseInt(this.state.monthPresensi) &&
        this.state.currentDay >= this.state.configStartDateAdmin &&
        this.state.currentDay <= this.state.configEndDateAdmin
        ? 1
        : 0;
    }
    // pegawai non eseleon
    else {
      return 0;
    }
  };

  handleChangeParent = (indexParent, indexChild, val) => {
    // update parent selected
    this.handleChange(indexChild, val);
    // update child selected all
    if (val.target.value) {
      this.setState(
        (prevState) => {
          const updatedCriteriaSelected = [...prevState.criteriaSelected];
          const min = this.state.indexs[indexParent].min;
          const max = this.state.indexs[indexParent].max;
          for (let i = min; i <= max; i++) {
            updatedCriteriaSelected[i] = val.target.value;
          }
          return {
            criteriaSelected: updatedCriteriaSelected,
          };
        },
        () => {
          // console.log(this.state.criteriaSelected);
        }
      );
    }
  };

  penilaianHistory = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    this.detailBloc.fetchComponentHistory({
      status: 1,
      uuid: queryParams.get("uuid"),
    });
  };

  handleChange = (index, val) => {
    if (val.target.value) {
      this.setState(
        (prevState) => {
          const updatedCriteriaSelected = [...prevState.criteriaSelected];
          updatedCriteriaSelected[index] = val.target.value;
          return {
            criteriaSelected: updatedCriteriaSelected,
          };
        },
        () => {}
      );
    }
  };

  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          // redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  constructor(props) {
    super(props);

    this.state = {
      monthFilter: moment().format("M"),
      yearFilter: moment().format("YYYY"),
    };

    this.state = {
      roleId: localStorage.getItem("currentRoleId"),
      loadingTable: false,
      loadingDetail: true,
      redirect: false,
      detai: {},
      hukdis: null,
      listCriteria: [],
      criteriaParentSelected: [],
      listComponents: [],
      criteriaSelected: [],
      configPenilaian: 0,
      configValue: 0,
      // untuk tooltip
      tooltip: false,
      tooltipStyle: {
        marginBottom: 2,
        backgroundColor: "#000",
        color: "#FFF",
        border: "1px solid #000",
      },
      indexs: [],

      currentDay: parseInt(moment().format("D")),
      currentMonth: moment().format("M"),
      currentYear: moment().format("YYYY"),

      // filter ubah data
      categories: [
        "9d05d51a-a28d-42e5-9938-21e8640f1a67", // STAFF KHUSUS
        "70e4cc97-56bd-4d22-bc75-363b13eaff82", // INTERNAL POLRI
        "81c7fc7f-08b6-4781-8ce3-b3e55ce03fa9", // INTERNAL TNI
        "a1db6606-5a44-4d59-ac7a-d1c8a4b624e3", // KOHLI
      ],
      positions: ["516f3bd6-e9bb-462d-8e00-bf04b93406b8"],
      configStartDateEselon: null,
      configEndDateEselon: null,
      configStartDateAdmin: null,
      configEndDateAdmin: null,
      statusVerifikasi: 0,
      detail: {},
    };
  }

  monthPenilaian(month, type) {
    // 1 penilaian ,
    if (type == 1) {
      if (month == 1) {
        return 11;
      } else if (month == 2) {
        return 12;
      } else {
        return month - 2;
      }
    }

    // 2 presensi
    if (type == 2) {
      if (month == 1) {
        return 12;
      } else {
        return month - 1;
      }
    }
  }

  yearPenilaian(month, type) {
    // 1 penilaian ,
    if (type == 1) {
      if (month == 1) {
        return this.state.yearFilter
          ? JSON.parse(this.state.yearFilter) - 1
          : moment().format("YYYY") - 1;
      } else if (month == 2) {
        return this.state.yearFilter
          ? JSON.parse(this.state.yearFilter) - 1
          : moment().format("YYYY") - 1;
      } else {
        return this.state.yearFilter
          ? JSON.parse(this.state.yearFilter)
          : moment().format("YYYY");
      }
    }
    // 2 presensi
    if (type == 2) {
      if (month == 1) {
        return this.state.yearFilter
          ? JSON.parse(this.state.yearFilter) - 1
          : moment().format("YYYY") - 1;
      } else {
        return this.state.yearFilter
          ? JSON.parse(this.state.yearFilter)
          : moment().format("YYYY");
      }
    }
  }

  componentDidMount() {
    this.detailBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loadingDetail: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              detail: response.result,
              loadingDetail: false,

              presensi: response.presensi ? response.presensi : 0,
              skp: response.skp ? response.skp : 0,
              penilaian: response.penilaian ? response.penilaian : 0,
              yearFilter: response.year,
              monthFilter: response.month,
              // periode presensi
              monthPresensi: this.state.monthFilter
                ? this.monthPenilaian(JSON.parse(this.state.monthFilter, 2))
                : this.monthPenilaian(moment().format("M"), 1),
              yearPresensi: this.state.monthFilter
                ? this.yearPenilaian(JSON.parse(this.state.monthFilter), 2)
                : this.yearPenilaian(moment().format("M"), 1),
              configStartDateEselon: response.config_eselon
                ? response.config_eselon.special_allowance_period_start_date
                : null,
              configEndDateEselon: response.config_eselon
                ? response.config_eselon.special_allowance_period_end_date
                : null,
              configStartDateAdmin: response.config_admin
                ? response.config_admin.special_allowance_period_start_date
                : null,
              configEndDateAdmin: response.config_admin
                ? response.config_admin.special_allowance_period_end_date
                : null,
              statusVerifikasi: response.cek_verifikasi ? 1 : 0,
              employee_uuids: response.employee_uuids
                ? response.employee_uuids
                : [],
              configValue: response.config ? response.config.config_value : 1,
            });

            this.setState({
              configPenilaian:
                this.state.configValue == 0
                  ? 1
                  : (this.state.configStartDateEselon &&
                      this.state.configEndDateEselon) ||
                    (this.state.configStartDateAdmin &&
                      this.state.configEndDateAdmin)
                  ? this.checkCurrentMonth()
                  : 0,
            });

            // console.log("configValue setelah: " + this.state.configValue);
            // console.log(
            //   "configPenilaian setelah: " + this.state.configPenilaian
            // );
            // console.log(
            //   "configStartDateEselon setelah: " +
            //     this.state.configStartDateEselon
            // );
            // console.log(
            //   "configEndDateEselon setelah: " + this.state.configEndDateEselon
            // );
            // console.log(
            //   "configStartDateAdmin setelah: " + this.state.configStartDateAdmin
            // );
            // console.log(
            //   "configEndDateAdmin setelah: " + this.state.configEndDateAdmin
            // );
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.detailBloc.listComponentChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            // data untuk post
            let components = response.result
              .filter((item) => item.assessment_component_type === 2)
              .map((item) => "component_" + item.assessment_component_uuid);

            // data untuk criteria selected
            let initialCriteriaSelected = response.result.map(
              (item) => item.special_allowance_detail_assessment_criteria_uuid
            );

            this.setState({
              loading: false,
              dokumen_persyaratan: response.result,
              components: components,
              search_document: 2,
              loadingTable: false,
              listComponents: response.result,
              criteriaSelected: initialCriteriaSelected,
              indexs: Object.values(response.index).map((item) => ({
                min: item.min,
                max: item.max,
              })),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.detailBloc.listComponentHistoryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingHistory: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingHistory: true,
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              criteriaSelected: response.list_assestment_history
                ? response.list_assestment_history.result
                : [],
              loadingHistory: false,
              loading: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.detailBloc.listCriteriaChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              listCriteria: reformatCriteria(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.detailBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              loading: false,
              success: true,
            });

            setTimeout(() => {
              this.setState({
                redirect: true,
              });
            }, 1000);
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    const queryParams = new URLSearchParams(this.props.location.search);
    this.detailBloc.fetchDetail({ uuid: queryParams.get("uuid") });
    this.detailBloc.fetchComponent({
      status: 1,
      uuid: queryParams.get("uuid"),
    });
    this.detailBloc.fetchCriteria({ status: 1 });
  }

  componentWillUnmount() {
    this.detailBloc.detailChannel?.unsubscribe();
    this.detailBloc.listComponentChannel?.unsubscribe();
    this.detailBloc.listComponentHistoryChannel?.unsubscribe();
    this.detailBloc.listCriteriaChannel?.unsubscribe();
    this.detailBloc.createChannel?.unsubscribe();
  }

  render() {
    var number = 0;
    return (
      <Fragment>
        <style>
          {`
            .custom-arrow::before {
              content: "";
              position: absolute;
              width: 0;
              height: 0;
              border-top: 6px solid transparent;
              border-bottom: 6px solid transparent;
              border-right: 6px solid #000; /* Same color as tooltip background */
              top: 50%; /* Position arrow at the vertical center */
              left: -5px; /* Adjust position from the left */
              transform: translateY(-50%); /* Center the arrow vertically */
            }
          `}
        </style>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <CardTitle>Ubah Penilaian</CardTitle>
                    <CardSubtitle className="mb-3">
                      Informasi Detail Penilaian
                    </CardSubtitle>
                    <hr />
                    <Row className="mb-3">
                      <label className="col-md-3">Nama </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_employee_full_name !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_employee_full_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">NIP </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_employee_nip !== ""
                              ? this.state.detail
                                  .special_allowance_summary_employee_nip
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Kategori </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_employee_categories_name_full !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_employee_categories_name_full
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Jabatan </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {/* {this.state.detail
                              .special_allowance_summary_employee_current_position_name
                              ? this.state.detail
                                  .special_allowance_summary_employee_current_position_name
                              : this.state.detail
                                  .special_allowance_summary_employee_current_position_name} */}

                            {this.state.detail
                              .special_allowance_summary_employee_current_position_name ? (
                              <>
                                {
                                  this.state.detail
                                    .special_allowance_summary_employee_current_position_name
                                }
                              </>
                            ) : (
                              <>
                                <span style={{ color: "red" }}>
                                  {
                                    this.state.detail
                                      .special_allowance_summary_skp_position_name
                                  }
                                </span>{" "}
                              </>
                            )}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Pangkat </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_employee_current_rank_name !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_employee_current_rank_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Unit Kerja </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_employee_current_work_unit_name !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_employee_current_work_unit_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Periode Pembayaran </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_periode_year !== ""
                              ? this.state.detail
                                  .special_allowance_periode_year +
                                " " +
                                this.state.detail
                                  .special_allowance_summary_month_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_paid_leave_notes ? (
                              <span
                                style={{
                                  color: "red",
                                  // fontSize: "0.85rem",
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: `(${this.state.detail.special_allowance_summary_paid_leave_notes})`,
                                }}
                              ></span>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "100%", height: 40 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="3">
                        <Button
                          color="danger"
                          disabled={this.state.cek_history == 0 ? true : false}
                          onClick={(e) => this.penilaianHistory()}
                        >
                          <i className="uil-history-alt"></i> Gunakan Penilaian
                          Bulan Sebelumnya
                        </Button>
                      </Col>
                    </Row>
                    <hr />
                    <br />

                    <Table className="table table-striped table-bordered">
                      {this.state.loadingTable === false ? (
                        this.state.listComponents.length > 0 ? (
                          this.state.listComponents.map((data, index) => {
                            if (data.assessment_component_type == 1) {
                              number = 0;
                              return (
                                <thead className="table-primary">
                                  <tr style={{ border: "1px solid #c8cce1" }}>
                                    <th
                                      className="text-center align-middle"
                                      width="5%"
                                    >
                                      No
                                    </th>
                                    <th
                                      className="text-center align-middle"
                                      width="70%"
                                    >
                                      {data.assessment_component_name}
                                    </th>
                                    <th
                                      className="text-center align-middle"
                                      width="25%"
                                    >
                                      Nilai{" "}
                                      <i
                                        id="info"
                                        className="fa fa-info-circle fa-lg"
                                      ></i>
                                      <Tooltip
                                        className="text-left"
                                        style={this.state.tooltipStyle}
                                        arrowClassName="custom-arrow"
                                        placement="right"
                                        isOpen={this.state["info"]}
                                        target="info"
                                        toggle={() => {
                                          this.setState({
                                            ["info"]: !this.state["info"],
                                          });
                                        }}
                                      >
                                        {this.state.listComponents.length > 0
                                          ? this.state.listCriteria.map(
                                              (criteria, i) => (
                                                <>
                                                  {criteria.label} :{" "}
                                                  {criteria.tooltip} <br></br>
                                                </>
                                              )
                                            )
                                          : ""}
                                      </Tooltip>
                                      <Col md="12">
                                        <AvRadioGroup
                                          name={`parent_${data.special_allowance_detail_index}`}
                                          // required
                                          errorMessage="Pilih salah satu"
                                          value={
                                            this.state.criteriaParentSelected[
                                              index
                                            ]
                                          }
                                          onClick={(e) =>
                                            this.handleChangeParent(
                                              data.special_allowance_detail_index,
                                              index,
                                              e
                                            )
                                          }
                                        >
                                          <AvField
                                            name={`hiddenparent_${data.special_allowance_detail_index}`}
                                            type="hidden"
                                            className="form-control"
                                            validate={{
                                              required: { value: false },
                                            }}
                                            // value={
                                            //   this.state.criteriaParentSelected[
                                            //     index
                                            //   ]
                                            // }
                                            errorMessage="Pilih Kategori"
                                          />

                                          {this.state.listCriteria.map(
                                            (criteria, i) => (
                                              <div
                                                key={i}
                                                className="form-check-inline"
                                              >
                                                <label>
                                                  <AvRadio
                                                    label={criteria.label}
                                                    value={criteria.value}
                                                  />
                                                </label>
                                                {/* <Tooltip
                                                  style={
                                                    this.state.tooltipStyle
                                                  }
                                                  arrowClassName="custom-arrow"
                                                  placement="right"
                                                  isOpen={
                                                    this.state[
                                                      `criteria-${criteria.value}`
                                                    ]
                                                  }
                                                  target={`criteria-${criteria.value}`}
                                                  toggle={() => {
                                                    this.setState({
                                                      [`criteria-${criteria.value}`]:
                                                        !this.state[
                                                          `criteria-${criteria.value}`
                                                        ],
                                                    });
                                                  }}
                                                >
                                                  {criteria.tooltip}
                                                </Tooltip> */}
                                              </div>
                                            )
                                          )}
                                        </AvRadioGroup>
                                      </Col>
                                    </th>
                                  </tr>
                                </thead>
                              );
                            } else if (data.assessment_component_type == 2) {
                              number = number + 1;
                              return (
                                <tbody>
                                  <tr
                                    key={`tr_tunkin_${index}`}
                                    style={{ border: "1px solid #c8cce1" }}
                                  >
                                    <td className="text-center">{number}</td>
                                    <td className="text-left">
                                      {data.assessment_component_name}
                                    </td>
                                    <td className="text-center">
                                      <Col md="12">
                                        <AvRadioGroup
                                          name={`select-${data.assessment_component_uuid}`}
                                          required
                                          errorMessage="Pilih salah satu"
                                          value={
                                            this.state.criteriaSelected[index]
                                          }
                                          onChange={(e) =>
                                            this.handleChange(index, e)
                                          }
                                        >
                                          <AvField
                                            name={`component_${data.assessment_component_uuid}`}
                                            type="hidden"
                                            className="form-control"
                                            validate={{
                                              required: { value: true },
                                            }}
                                            id={`component_${data.assessment_component_uuid}`}
                                            value={
                                              this.state.criteriaSelected[index]
                                            }
                                            errorMessage="Pilih Kategori"
                                          />

                                          {this.state.loadingTable === false ? (
                                            this.state.listComponents.length >
                                            0 ? (
                                              this.state.listCriteria.map(
                                                (criteria, i) => (
                                                  <div
                                                    key={i}
                                                    className="form-check-inline"
                                                  >
                                                    <AvRadio
                                                      label={criteria.label}
                                                      value={criteria.value}
                                                      id={`criteria-${data.assessment_component_uuid}-${criteria.value}`}
                                                    />
                                                    <Tooltip
                                                      style={
                                                        this.state.tooltipStyle
                                                      }
                                                      arrowClassName="custom-arrow"
                                                      placement="right"
                                                      isOpen={
                                                        this.state[
                                                          `criteria-${data.assessment_component_uuid}-${criteria.value}`
                                                        ]
                                                      }
                                                      target={`criteria-${data.assessment_component_uuid}-${criteria.value}`}
                                                      toggle={() => {
                                                        this.setState({
                                                          [`criteria-${data.assessment_component_uuid}-${criteria.value}`]:
                                                            !this.state[
                                                              `criteria-${data.assessment_component_uuid}-${criteria.value}`
                                                            ],
                                                        });
                                                      }}
                                                    >
                                                      {criteria.tooltip}
                                                    </Tooltip>
                                                  </div>
                                                )
                                              )
                                            ) : (
                                              <tr
                                                style={{
                                                  border: "1px solid #c8cce1",
                                                }}
                                              >
                                                <td
                                                  colSpan="17"
                                                  className="text-center"
                                                >
                                                  Tidak Ada Data
                                                </td>
                                              </tr>
                                            )
                                          ) : (
                                            <tr
                                              style={{
                                                border: "1px solid #c8cce1",
                                              }}
                                            >
                                              <td
                                                colSpan="17"
                                                className="text-center"
                                                style={{ position: "relative" }}
                                              >
                                                <div
                                                  style={{
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform:
                                                      "translate(-50%, -50%)",
                                                  }}
                                                >
                                                  <Spinner
                                                    className="m-2"
                                                    color="primary"
                                                  />
                                                  Memuat Data...
                                                </div>
                                              </td>
                                            </tr>
                                          )}
                                        </AvRadioGroup>
                                      </Col>
                                    </td>
                                  </tr>
                                </tbody>
                              );
                            }
                          })
                        ) : (
                          <tr style={{ border: "1px solid #c8cce1" }}>
                            <td colSpan="17" className="text-center">
                              Tidak Ada Data
                            </td>
                          </tr>
                        )
                      ) : (
                        <tr style={{ border: "1px solid #c8cce1" }}>
                          <td
                            colSpan="17"
                            className="text-center"
                            style={{ position: "relative" }}
                          >
                            {/* <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                              }}
                            >
                              <Spinner className="m-2" color="primary" />
                              Memuat Data...
                            </div> */}
                            <div
                              className="md-12 text-center"
                              style={{
                                alignItems: "center",
                                left: "50%",
                              }}
                            >
                              <Spinner
                                className="text-center"
                                color="primary"
                              />
                              <div>Memuat Data</div>
                            </div>
                          </td>
                        </tr>
                      )}

                      {/* <tbody>
                        {this.state.loadingTable === false ? (
                          this.state.listComponents.length > 0 ? (
                            this.state.listComponents.map((data, index) => {
                              const adjustedIndex = index + 1;

                              return (
                                <tr
                                  key={`tr_tunkin_${index}`}
                                  style={{ border: "1px solid #c8cce1" }}
                                >
                                  <td className="text-center">
                                    {adjustedIndex}
                                  </td>
                                  <td className="text-left">
                                    {data.assessment_component_name}
                                  </td>
                                  <td className="text-left">
                                    <Col md="12">
                                      <AvRadioGroup
                                        name={`select-${data.assessment_component_uuid}`}
                                        required
                                        errorMessage="Pilih salah satu"
                                      >
                                        {this.state.listCriteria.map(
                                          (criteria, i) => (
                                            <div
                                              key={i}
                                              className="form-check-inline"
                                            >
                                              <AvRadio
                                                label={criteria.label}
                                                value={criteria.value}
                                              />
                                            </div>
                                          )
                                        )}
                                      </AvRadioGroup>
                                    </Col>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr style={{ border: "1px solid #c8cce1" }}>
                              <td colSpan="17" className="text-center">
                                Tidak Ada Data
                              </td>
                            </tr>
                          )
                        ) : (
                          <tr style={{ border: "1px solid #c8cce1" }}>
                            <td colSpan="17" className="text-center">
                              <Spinner className="m-2" color="primary" />
                            </td>
                          </tr>
                        )}
                      </tbody> */}
                    </Table>

                    <br />
                    <Row className="mb-3">
                      {/* <Col md="3"></Col> */}
                      <Col md="9">
                        <Link
                          to={`/kepegawaian/penilaian_tunjangan_khusus.html`}
                        >
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        {/* {
                          // eselon 1 dan 2
                          (this.state.loadingDetail == false &&
                            this.state.roleId == 2 &&
                            this.is_eselon == 1 &&
                            this.state.statusVerifikasi == 0) ||
                          // administrator (menteri, kohli, stafsus, internal POLRI, internal TNI, Deputi. riieke)
                          (this.state.loadingDetail == false &&
                            this.state.roleId == 1 &&
                            this.state.statusVerifikasi == 0 &&
                            (this.state.categories.includes(
                              this.state.detail
                                .special_allowance_summary_employee_categories_uuid
                            ) ||
                              this.state.positions.includes(
                                this.state.detail.employee_current_position_uuid
                              ) ||
                              this.state.employee_uuids.includes(
                                this.state.detail.employee_uuid
                              ))) ? ( */}
                        {(this.state.loadingDetail == false &&
                          this.state.roleId == 2 &&
                          this.state.statusVerifikasi == 0) ||
                        (this.state.loadingDetail == false &&
                          this.state.roleId == 1 &&
                          this.state.statusVerifikasi == 0) ? (
                          <>
                            <Button color="success" type="submit">
                              <i className="uil-arrow-up-right"></i> Ubah Data
                            </Button>
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan penilaian ini ?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to={"/kepegawaian/penilaian_tunjangan_khusus.html"} />
        ) : null}
      </Fragment>
    );
  }
}

export default withRouter(UpdatePenilaianView);
